import React from 'react'
import { Dialog } from '@material-ui/core'
import './dialogWarningGL.css'


const iconMap = {
  confirmation: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICON_MODAL_CONFIRMATION}`,
  error: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICON_MODAL_ERROR}`,
  info: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICON_MODAL_INFORMATION}`,
  success: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICON_MODAL_SUCCESS}`,
  warning: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICON_MODAL_WARNING}`,
};

const DialogWarningGL = ({
  open,
  onClose,
  title = '',
  description = '',
  messageButton,
  type = '',
  toggleCompletedRequesting
}) => {

  const iconSrc = iconMap[type]

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(event);
        }
      }}
      fullWidth
      maxWidth='xs'
      id='dialogErrorGL'
      disableScrollLock={true}
      transitionDuration={0}
    >
      <div className='dialogErrorGL-title-modal' >
        <span>{title}</span>
        <button
          onClick={onClose}
          className='dialogErrorGL-button-x'
        >
          X
        </button>
      </div>

      <div>
        <div className='dialogErrorGL-content'>
          <div className='dialogErrorGL-subcontent'>
            {iconSrc && (
              <img src={iconSrc} alt={`${type}-icon`} className='dialogErrorGL-imgNotification' />
            )}
            <span className='dialogErrorGL-description'>{description}</span>
          </div>
          <div className='dialogErroGL-button'>
            <button
              className='dialogErrorBtnHLPure-primary-btn'
              onClick={toggleCompletedRequesting || onClose}
            > {messageButton}</button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogWarningGL;
